import React, { Component } from "react";

import Events from "./services/events.service";

import { Route, Redirect, Switch } from "react-router-dom";

// import { withRouter } from 'react-router-dom';
import Error from "./Modules/error/error";
import { HashRouter as Router } from "react-router-dom";
import "./New.css";

import MainSpinner from "./components/Spinners/MainSpinner";

import SummaryModal from "./Modules/summary/summary_modal";

import asyncComponent from "./services/AsyncComponent";

import Business from "./services/business.service";

import UserWay from "./services/userway.service";

import Storage from "./services/storage.service";
import Settings from "./services/settings";
import Globals from "./services/globals";
import User from "./services/user";
import HTTP from "./services/http.service";

import { unreserveNumber } from "./services/number.service";
import PlansService from "./services/plans.service";
import Products from "./services/products.service";

import Helpers from "./services/helpers";

import BodyClasses from "./components/BodyClasses/BodyClasses";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Chat from "./Modules/Chat/chat";

import Translation from "./services/translation";

import HomeRouter from "./Modules/HomeRouter";

import Flow from "./services/flow.service";

import BlockingMaintenance from "./Modules/Plans/BlockingMaintenance";

import { createBrowserHistory } from 'history';
const history = createBrowserHistory({
	basename: "", // The base URL of the app (see below)
	hashType: "hash", // The hash type to use (see below)
});

const AsyncIDCheck = asyncComponent(() => {
	return import("./Modules/IDCheck/id");
});

const AsyncRegister = asyncComponent(() => {
	return import("./Modules/Register/Register");
});

const AsyncTerminated = asyncComponent(() => {
	return import("./Modules/Register/terminated");
});

const AsyncNumberRandom = asyncComponent(() => {
	return import("./Modules/Number/Number");
});

const AsyncTransferNumber = asyncComponent(() => {
	return import("./Modules/Number/transfer");
});

const AsyncTransferTerms = asyncComponent(() => {
	return import("./Modules/Number/transfer-terms");
});

const AsyncNumberSearch = asyncComponent(() => {
	return import("./Modules/Number/Search");
});

const AsyncNumberConfirmation = asyncComponent(() => {
	return import("./Modules/Number/Confirmation");
});

const AsyncPlans = asyncComponent(() => {
	return import("./Modules/Plans/PlansPage");
});

const AsyncCustomPlan = asyncComponent(() => {
	return import("./Modules/Plans/CustomPlan");
});

const AsyncPayment = asyncComponent(() => {
	return import("./Modules/Payment/payment.component");
});

const AsyncDeliveryClosed = asyncComponent(() => {
	return import("./Modules/SimDelivery/Delivery-closed");
});

const AsyncThankYou = asyncComponent(() => {
	return import("./Modules/SimDelivery/Thank-you");
});

const AsynchUpsell = asyncComponent(() => {
	return import("./Modules/Upsell/PlanUpsell");
})

const AsyncSimDelivery = asyncComponent(() => {
	return import("./Modules/SimDelivery/SimDelivery");
});

const AsyncSubmitDelivery = asyncComponent(() => {
	return import("./Modules/SimDelivery/SubmitDelivery");
});

const AsyncInstallments = asyncComponent(() => {
	if (window.innerWidth <= 640){
		return import("./Modules/IdUpload/Scan-or-upload")
	}else{
		return import("./Modules/IdUpload/IdUpload");
	}
});

const AsyncReceiveInstalments = asyncComponent(() => {
	return import("./Modules/Payment/receive");
});

const AsyncContractDelivery = asyncComponent(() => {
	return import("./Modules/ContractDelivery/ContractDelivery");
});

const AsyncGroupInvitation = asyncComponent(() => {
	return import("./Modules/GroupInvitation");
});

const AsyncVIPiPhonePlan = asyncComponent(() => {
	return import("./Modules/VIPiPhonePlan/VIPiPhonePlan");
});

const AsyncPhoneDeviceAddOn = asyncComponent(() => {
	return import("./Modules/Plans/PhoneDeviceAddOn/PhoneDeviceAddOn");
});

const AsyncMinorsPlan = asyncComponent(() => {
	return import("./Modules/Plans/minors/MinorsPlanSelector");
});

const AsyncActivationMethod = asyncComponent(() => {
	return import("./Modules/ActivationMethods/ChooseActivationMethod");
});

const AsyncScanFace = asyncComponent(() => {
	return import("./Modules/MOI/FacialRecognitionMOI/ScanFace");
});

const AsyncScanDocument = asyncComponent(() => {
	return import("./Modules/MOI/DocumentReaderMOI/ScanDocument")
});

const AsyncUploadDocument = asyncComponent(() => {
	return import("./Modules/MOI/DocumentReaderMOI/UploadDocument");
});


const ui_map = {
	number: AsyncNumberRandom,
	plan: AsyncPlans,
	upsell: AsynchUpsell,
	account: AsyncRegister,
	activation_method: AsyncActivationMethod,
	payment: AsyncPayment,
	delivery: AsyncSimDelivery,
	id_check: AsyncIDCheck,
	submit_delivery: AsyncSubmitDelivery,
	thank_you: AsyncThankYou,
	group_invitation: AsyncGroupInvitation,
	vip_iphone_plan: AsyncVIPiPhonePlan,
	phone_device_addon: AsyncPhoneDeviceAddOn,
	minors_plans: AsyncMinorsPlan
};

export default class App extends Component {
	history_listener = null;

	state = {
		routeTo: null,
		translations_loaded: false,
		business_loaded: "",
		code: "",
		error_obj: null,
		flow_loaded: false,
		step: null,
		maintenance_mode: null
	}; 

	params = {};

	old_flags = null;

	gotoRecommended = () => {
		User.flowStatus(1)
			.then((response) => {

				if(Helpers.isExceptionRoute()){
					if (window.location.href.indexOf("/installment-success") !== -1) {
						Storage.set("loading_text",'Please keep this window open while we complete your order')
						Flow.goTo("/installment-success")
					}
					if (window.location.href.indexOf("/installment-fail") !== -1) {
						Storage.set("loading_text","Oops, your payment didn't go through! Please try again")
						Flow.goTo("/installment-fail");
					}
					if (window.location.href.indexOf("/contract-request") !== -1) {
						let url_params = Helpers.getParams();
						let session_id_param = url_params.pieces['session-id'] ? `?session-id=${url_params.pieces['session-id']}` : '';
						Flow.goTo(`/contract-request${session_id_param}`);
					}
				} else {
					let recommended = Flow.getRecommendedRoute("statttt");
					Flow.goToRouteWithChecks(recommended);
				}

				
				this.forceUpdate();
			})
			.catch((error) => {
				Globals.handleError(true, "50");
			});
	}

	goToStatusRoute = () => {
		Products.init();
		
		this.gotoRecommended();
	};

	setRoute = (val, set_loading = false, callee = "") => {
		this.setState({ routeTo: val });
		if (
			set_loading &&
			this.state.translations_loaded &&
			this.state.business_loaded &&
			!Storage.get("loading_text")
		) {
			let strings = Translation["keys"][Translation.activeLang];
			Storage.set("loading_text", strings["LOADING_MESSAGE_GENERAL"]); //componentDidUpdate
		}
	};

	checkUser = () => {
		if (!User.isLoggedIn()) {
			Products.clear();

			// Events.when_user_logs_out();

			Storage.clear("eCommerceObj");
			Storage.clear("selectedPlan");
			Storage.clear("selectedProduct");

			User.loginByDeviceID()
				.then((response) => {
					HTTP.set_session(response.data.session_id);
					HTTP.set_device_id(HTTP.get_device_id());

					setTimeout(() => {
						Storage.set("session", response.data.session_id, true);
						Storage.set("uid", response.data.profile.uid, true);

						// Events.when_user_session_is_found();
						// Events.when_user_id_is_found(response.data.profile.uid);

						// if (!Storage.get("account_id")) {
						// 	User.profile()
						// 		.then((response) => {
						// 			if (response.data.profile.account_id) {
						// 				Storage.set(
						// 					"account_id",
						// 					response.data.profile.account_id,
						// 					true
						// 				);
						// 				Events.when_user_account_id_is_set(
						// 					response.data.profile.account_id
						// 				);
						// 			}
						// 		})
						// 		.catch((error) => {
						// 			Globals.handleError(error, "1");
						// 		});
						// }
					}, 300);

				})
				.catch((error) => {
					Globals.handleError(error, "2");
				});
		}
	};

	inits = () => {
		Events.initTracking();

		User.init();

		Business.getBusinessConfig();

		if (Settings.fb_app_id) {
			(function(d, s, id) {
				var js,
					fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) {
					return;
				}
				js = d.createElement(s);
				js.id = id;
				js.src = "https://connect.facebook.net/en_US/sdk.js";
				fjs.parentNode.insertBefore(js, fjs);
			})(document, "script", "facebook-jssdk");
		}

		window.fbAsyncInit = function() {
			window.FB.init({
				appId: Settings.fb_app_id,
				cookie: true,
				xfbml: false,
				version: 'v21.0',
			});

			window.FB.AppEvents.logPageView();
			let fbInitEvent = new Event("FBObjectReady");
			document.dispatchEvent(fbInitEvent);
		};
	};

	showUserway = () =>{
		UserWay.addWidget();	
	}

	componentDidMount() {
		this.inits();

		// @temp
		if(window.location.href.indexOf("/join/installment-success") !== -1){
			window.location.href = window.location.href.replace("/join/installment-success", "/join/#/installment-success");
		}
		if(window.location.href.indexOf("/join/installment-fail") !== -1){
			window.location.href = window.location.href.replace("/join/installment-fail", "/join/#/installment-fail");
		}
		if(window.location.href.indexOf("/join/contract-request") !== -1){
			window.location.href = window.location.href.replace("/join/contract-request", "/join/#/contract-request");
		}
		let params = Helpers.getParams();
		if (!Storage.get("originalAppURL")){
			Storage.set("originalAppURL", window.location.href);
		}
		if(params.pieces?.code){
			Storage.set("invitation_code", params.pieces.code);
		}
		let contract_request_page_loaded = window.location.href.indexOf("contract-request") !== -1;
		if (contract_request_page_loaded){
			sessionStorage.setItem("contract_request_session_id", params.pieces['session-id']);
		}
		let is_trying_to_search =
			window.location.href.indexOf("number/search") !== -1;
		if (params.pieces.vip) {
			Storage.set("filter_vip", params.pieces.vip, true);
		}
		if (params.pieces.search || is_trying_to_search) {
			Storage.set("search", true);
		}
		if (params.pieces.preset) {
			Storage.set("preset", params.pieces.preset);
		}
		if (params.pieces.plantype) {
			Storage.set("plantype", params.pieces.plantype);
		}
		if (params.pieces.gclid) {
			Storage.set("gclid", params.pieces.gclid, true);
		}
		if(document.referrer.includes("vip-plans") && !Storage.get('filter_vip')){
			Storage.set('isComingFromVipPlans', true, true)
		}
		if (Settings.enable_history) {
			// this.history_listener = history.listen((location, action) => {
			// 	if (location.hash) {
			// 		let data = location.hash.replace("#/", "/");
			// 		if (data) {
			// 			// this.setRoute(data, false, '1');
			// 			Flow.goTo(data);
			// 		}
			// 	}
			// });

			let old_route;
				Flow.get_route().subscribe((data) => {
					let hash = history.location.hash;
					if (data && (hash !== "#" + data || data !== old_route)) {
						// console.log("pushed data = #" + data);
						history.push("#" + data, { some: "state" });
					}
					old_route = data;
				})
		}

			Storage.get_obsrv("step").subscribe((data) => {
				if (data !== this.state.step) {
					this.setState({
						step: data,
					});
				}
			})

			Storage.get_obsrv("flow_status_flags").subscribe((newFlags) => {
				let had_vip_and_lost_it = false;
				if (
					this.old_flags &&
					newFlags &&
					this.old_flags.is_number_selected &&
					!newFlags.is_number_selected
				) {
					had_vip_and_lost_it = true;
				}
				if (had_vip_and_lost_it) {
					Products.saveCurrentProduct().then(res=>{
						PlansService.getSavedPlans().then(res=>{

						}).catch(err=>{})
					}).catch(error=>{
						PlansService.getSavedPlans().then(res=>{}).catch(err=>{})
					});
				}
				if (newFlags) {
					this.old_flags = newFlags;
				}
			})

			Storage.get_obsrv("reset_flow").subscribe((data) => {
				if (data) {
				let error = this.state.error_obj;
				if (error?.code === -176){
					// unreserve selected number because it is incompatible with current plan
					unreserveNumber();
				}
				Flow.goHome();
				Storage.clear("error");
				Storage.clear("ok_clear_error_redirect");
				this.setState({
					error_obj:null
				})
					
				}
			})

			Storage.get_obsrv("ok_clear_error_redirect").subscribe((data) => {
				if (data) {
					Flow.goHome();
					Storage.clear("ok_clear_error_redirect");
					Storage.clear("error");
					Storage.clear("payment_processing");
					Storage.clear("payment_error");
					Storage.clear("processing_cybersouce");
				}
			})

			Storage.get_obsrv("ok_clear_error_get_status").subscribe((data) => {
				if (data) {
					User.flowStatus("ok_clear_error_get_status")
						.then((response) => {
							Storage.clear("error");
							Storage.clear("ok_clear_error_get_status");
							Storage.clear("error");
							Storage.clear("payment_error");
							Storage.clear("payment_processing");
							Storage.clear("processing_cybersouce");

							let recommended = Flow.getRecommendedRoute(
								"ok_clear_error_get_status"
							);
							Flow.goToRouteWithChecks(recommended);

							this.forceUpdate();
						})
						.catch((error) => {
							Globals.handleError(true, "502");
						});
				}
			})

			Storage.get_obsrv("ok_clear_error").subscribe((data) => {
				if (data) {
					Storage.clear("error");
					Storage.clear("payment_error");
					Storage.clear("ok_clear_error");
					Storage.clear("error");
					Storage.clear("payment_processing");
					Storage.clear("processing_cybersouce");
				}
			})

			Storage.get_obsrv("max_sims_redirect").subscribe((data) => {
				if (data) {
					window.location.href = 'https://www.virginmobile.ae/help/sim-limit-reached/';
				}
			})

			Storage.get_obsrv("redirect_to_app_chat").subscribe((data) => {
				if (data) {
					let appLink = Settings.deeplink_domain
					if (appLink) {
						window.location.href = `${appLink}/chat`;
					}
				}
			})

			Storage.get_obsrv("redirect_to_id_check").subscribe((data) => {
				if (data) {
					Storage.clear("error");
					Storage.clear("redirect_to_id_check");
					Flow.goTo("/residency");
				}
			})

			Storage.get_obsrv("redirect_to_activation_method").subscribe((data) => {
				if (data) {
					Storage.clear("error");
					Storage.clear("redirect_to_activation_method");
					Flow.goTo("/activation_method");
				}
			})

		console.log(
			"%c%s",
			"border-top:1px solid #e1090a;width:100%",
			"                                                    "
		);
		console.log(
			"%c%s",
			"color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 10pt",
			"Virgin Mobile"
		);
		console.log(
			"%c%s",
			"color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 8pt",
			"Emirates Integrated Telecommunications Company PJSC"
		);

		console.log(
			"%c Build No: ",
			"color: white; background-color: #2274A5",
			Settings["buildNumber"]
		);

		if (Settings["deployedAt"]) {
			console.log(
				"%c Deployed on: ",
				"color: white; background-color: #4c8613",
				Settings["deployedAt"]
			);
		}
		console.log(
			"%c%s",
			"border-bottom:1px solid #e1090a;width:100%",
			"                                                    "
		);

		Translation.getTranslationsObsrv().subscribe((data) => {
			if (data) {
				this.setState({
					translations_loaded: true,
					agent: navigator.userAgent.toLowerCase(),
				});

				// let app_link = "";
				// let user_agent_str = navigator.userAgent.toLowerCase();
				// if (user_agent_str.indexOf("android") !== -1) {
				// 	app_link = Settings.google_play_link;
				// } else {
				// 	if (
				// 		user_agent_str.indexOf("iphone") !== -1 ||
				// 		user_agent_str.indexOf("ipad") !== -1
				// 	) {
				// 		app_link = Settings.app_store_link;
				// 	} else {
				// 		app_link = false;
				// 	}
				// }
				// Storage.set("app_link", app_link);

					Storage.get_obsrv("error").subscribe((data) => {
						if (data) {
							let error_type = data["type"];
							if (Settings.debug_errors) console.log("error", error_type);
							let error_obj = Globals["messages"].error_general;
							if (Globals["messages"][error_type]) {
								error_obj = Globals["messages"][error_type];
							}
							if (data["code"]) {
								error_obj["code"] = data["code"];
							}

							this.setState({
								loading: false,
								// with_error: true,
								error_obj: error_obj,
							});
						} else {
							this.setState({
								loading: false,
								// with_error: false,
								error_obj: null,
							});
						}
					})
			}
		});

		Storage.get_obsrv("businessConfig").subscribe((data) => {
			if (data) {
				this.setState({
					business_loaded: true,
					maintenance_mode: data.maintenance_mode
				});
				this.showUserway();
				if (Settings.convert_project_id && data["enable_convert_websignup"]) {
					// (function(parent, id) {
					// 	var fjs = parent.getElementsByTagName("title")[0];
					// 	if (parent.getElementById(id)) {
					// 		return;
					// 	}
					// 	var js = parent.createElement("script");
					// 	js.id = id;
					// 	js.async = true;
					// 	js.type = "text/javascript";
					// 	js.src =
					// 		"//cdn-3.convertexperiments.com/js/" +
					// 		Settings.convert_project_id +
					// 		".js";
					// 	fjs.parentNode.insertBefore(js, fjs);

					// 	js.onload = function() {
					// 		if (window.convert) {
					// 			window.convert.$(document).ready(function() {
					// 				window.convert.$(window).on("hashchange", function() {
					// 					window.convert_conv_q = window.convert_conv_q || [];
					// 					window.convert_conv_q.push(["run", "true"]);
					// 				});
					// 			});
					// 		}
					// 	};
					// })(document, "convert-experiments");




					//check if convert script loaded already:
					const convertLoaded = document.getElementById("convert-experiments");
					if (!convertLoaded){
						const script = document.createElement("script");
						script.src = `//cdn-4.convertexperiments.com/v1/js/${Settings.convert_project_id}.js`;
						script.id = "convert-experiments";
						script.async = true;
						const staticScript = document.createElement("script");
						staticScript.innerHTML = 'var _conv_page_type="home";';
						document.head.appendChild(staticScript);
						document.head.appendChild(script);
					}
				}
			} else {
				if (data === false) {
					this.setState({
						business_loaded: false,
					});
				}
			}
		});

		Flow.get_load_status().subscribe((data) => {
			this.setState({
				flow_loaded: data,
			});
		});

		// this.waitForAbTest();
		this.init();
		history.listen(() => {
   window.scrollTo(0, 0)
		});
	}

	init = () => {
		Flow.init();

		// let fetching_me = false;

		Storage.get_obsrv("session").subscribe((data) => {
			if (data) {
				// if (!Storage.get("account_id") && !fetching_me) {
				// 	fetching_me = true;
					
				// 	User.profile()
				// 		.then((response) => {
				// 			fetching_me = false;
				// 			if (response.data.profile.account_id) {
				// 				Storage.set(
				// 					"account_id",
				// 					response.data.profile.account_id,
				// 					true
				// 				);
				// 				Events.when_user_account_id_is_set(
				// 					response.data.profile.account_id
				// 				);
				// 			}
				// 		})
				// 		.catch((error) => {
				// 			fetching_me = false;
				// 			Globals.handleError(error, "3");
				// 		});
				// }

			

				this.goToStatusRoute();

			} else {
				this.checkUser();
			}
		});
	};

	shouldComponentUpdate(nextProps, nextState) {
		if (
			this.state.routeTo !== nextState.routeTo ||
			this.state.step !== nextState.step ||
			this.state.flow_loaded !== nextState.flow_loaded ||
			this.state.translations_loaded !== nextState.translations_loaded ||
			this.state.business_loaded !== nextState.business_loaded ||
			this.state.error_obj !== nextState.error_obj ||
			this.state.maintenance_mode !== nextState.maintenance_mode

		) {
			return true;
		}
		return false;
	}

	render() {
		let routeTo = ""; 

		if (this.state.routeTo) {
			routeTo = <Redirect to={this.state.routeTo} key={Date.now()} />;
		}

		// let home_route = <Route path="/" key={"/" + Date.now()} />;

		let main_routes = [];
		let routes_ui_map = ui_map;
		let settings_route_map = Settings.routes;
		for (let route of Object.keys(routes_ui_map)) {
			if (settings_route_map[route]) {
				main_routes.push(
					<Route
						exact
						path={settings_route_map[route]["path"]}
						key={settings_route_map[route]["path"]}
						component={routes_ui_map[route]}
					/>
				);
			}
		}

		let routes = "";

		if (this.state.flow_loaded) {
			routes = (
				<Switch>
					{main_routes}

					<Route path="/" exact key={"/" + Date.now()} component={HomeRouter} />
					<Route
						path="/number/transfer-terms"
						exact
						key={"/number/transfer" + Date.now()}
						component={AsyncTransferTerms}
					/>

					<Route
						path="/number/transfer"
						exact
						key={"/number/transfer" + Date.now()}
						component={AsyncTransferNumber}
					/>

					<Route
						path="/number/search"
						exact
						key={"/number-search" + Date.now()}
						component={AsyncNumberSearch}
					/>

					<Route
						path="/number/confirmation"
						exact
						key={"/number-confirmation" + Date.now()}
						component={AsyncNumberConfirmation}
					/>

					<Route
						path="/terminated"
						exact
						key={"/terminated" + Date.now()}
						component={AsyncTerminated}
					/>

					<Route
						path="/custom-plan"
						exact
						key={"/custom-plan" + Date.now()}
						component={AsyncCustomPlan}
					/>

					<Route
						path="/delivery-closed"
						exact
						key={"/delivery-closed" + Date.now()}
						component={AsyncDeliveryClosed}
					/>

					<Route
						path="/instalments"
						exact
						key={"/installments" + Date.now()}
						component={AsyncInstallments}
					/>

					<Route
						path="/installment-fail"
						key={"/installment-fail" + Date.now()}
						exact
						component={AsyncReceiveInstalments}
					/>

					<Route
						path="/installment-success"
						key={"/installment-success" + Date.now()}
						exact
						component={AsyncReceiveInstalments}
					/>

					<Route
						path="/contract-request"
						key={"/contract-request" + Date.now()}
						exact
						component={AsyncContractDelivery}
					/>
					
					<Route
						path="/activation_method/scan_face"
						exact
						key={"/scan-face" + Date.now()}
						component={AsyncScanFace}
					/>

					<Route
						path="/activation_method/scan_document"
						exact
						key={"/scan_document" + Date.now()}
						component={AsyncScanDocument}
					/>

					<Route
						path="/activation_method/upload_document"
						exact
						key={"/scan_document" + Date.now()}
						component={AsyncUploadDocument}
					/>
					<Redirect from="*" to={Flow.starting_path} />
				</Switch>
			);
		}

		let switcher = "";
		if (routeTo !== null) {
			switcher = routes;
		} else {
			switcher = "";
		}

		let rendered = "";
		if (this.state.translations_loaded) {
			if (this.state.business_loaded) {
				rendered = (
					<>
						{routeTo}
						{switcher}
					</>
				);
			} else {
				if (this.state.business_loaded === false) {
					let error_obj = Globals["messages"].error_fatal;

					rendered = <Error error={error_obj} />;
				}
			}
		}

		let error_screen = "";

		if (this.state.error_obj && this.state.translations_loaded) {
			error_screen = <Error error={this.state.error_obj} />;
		}

		let footer = "";
		let modals = "";
		if (this.state.translations_loaded && this.state.business_loaded) {
			footer = <Footer />;
			modals = <SummaryModal />;
		}

		let page_style = "vmo-plain-header";

		if (this.state.step) {
			page_style = "vmo-with-slant";
		}

		if (this.state.step === 1 || this.state.step === 11) {
			page_style = "vmo-plain-header";
		}

		if (this.state.step === 2){
			page_style = "vmo-with-slant vmo-with-bottom-left-slant";
		}
		
		if (this.state.step === "installments") {
			page_style = "vmo-plain-header";
		}

		return (
			<div className={"agent " + this.state.agent}>
				<BodyClasses />
				<div id="vmo">
					<div className={"vmo-wrapper vmo-onboarding " + page_style}>
						{this.state.translations_loaded ? (
							<Header variation={page_style} />
						) : (
							""
						)}
						
						{this.state.maintenance_mode === "maintenance_blocking" ? 
							this.state.translations_loaded && <BlockingMaintenance/> :
							<div className="vmo-onboarding-page" id="vmo-onboarding-page">
								<MainSpinner />
								<Router history={history}>{rendered}</Router>
								{error_screen}
							</div>
						}
						{footer}
						<div className="floaters">
							{Settings.enable_sendbird && this.state.business_loaded ? (
								<div className="send-bird-wrapper">
									<div className="send-bird-container">
									<Chat />
									</div>
								</div>
							) : (
								""
							)}
						</div>
					</div>
					{modals}
				</div>
			</div>
		);
	}
}
